/** Ported from PulseStylePresetsCatalog.builtIns (PulseStylePreset.swift). */
export const PULSE_PRESET_CATALOG = [
    {
        id: "flat-editorial",
        name: "Flat editoriale",
        prePrompt: "flat editorial illustration, soft pastel palette, minimal geometric shapes, generous negative space, subtle grain, magazine-quality composition",
        emoji: "📰",
        realism: "illustrative",
        sortOrder: 100,
    },
    {
        id: "cinematic-3d-render",
        name: "3D cinematografico",
        prePrompt: "high-end cinematic 3D render, octane lighting, soft volumetric god rays, glossy materials, shallow depth of field, modern art-direction",
        emoji: "🎬",
        realism: "illustrative",
        sortOrder: 110,
    },
    {
        id: "risograph-print",
        name: "Stampa risograph",
        prePrompt: "risograph print look, two-color overprint, visible halftone grain, slight registration offset, warm pinks and indigo blues, posterized shapes",
        emoji: "🖨️",
        realism: "illustrative",
        sortOrder: 120,
    },
    {
        id: "watercolor-analog",
        name: "Acquerello analogico",
        prePrompt: "loose watercolor wash, paper texture visible, soft pigment bleeds, organic edges, muted earthy palette, hand-painted feel",
        emoji: "🎨",
        realism: "illustrative",
        sortOrder: 130,
    },
    {
        id: "pixel-art-16bit",
        name: "Pixel art 16-bit",
        prePrompt: "16-bit pixel art, limited 32-color palette, crisp dithering, retro game console aesthetic, side-light shading, square pixels",
        emoji: "👾",
        realism: "illustrative",
        sortOrder: 140,
    },
    {
        id: "bauhaus-geometric",
        name: "Bauhaus geometrico",
        prePrompt: "Bauhaus-inspired geometric composition, primary colors (red, yellow, blue) on off-white, hard edges, balanced asymmetry, modernist typography sensibility",
        emoji: "🟥",
        realism: "illustrative",
        sortOrder: 150,
    },
    {
        id: "memphis-80s",
        name: "Memphis anni 80",
        prePrompt: "Memphis design 1980s aesthetic, vivid clashing colors, squiggles and confetti shapes, terrazzo patterns, playful asymmetric layout",
        emoji: "💠",
        realism: "illustrative",
        sortOrder: 160,
    },
    {
        id: "y2k-chrome",
        name: "Y2K cromato",
        prePrompt: "Y2K chrome aesthetic, polished liquid metal, holographic gradients, lens flares, futuristic 2000s tech-utopia vibe, cyber-blue and silver",
        emoji: "🪩",
        realism: "illustrative",
        sortOrder: 170,
    },
    {
        id: "cyberpunk-neon",
        name: "Cyberpunk neon",
        prePrompt: "cyberpunk neon-noir, rain-slicked streets, magenta and cyan neon glow, deep blacks, atmospheric haze, cinematic high contrast",
        emoji: "🌃",
        realism: "illustrative",
        sortOrder: 180,
    },
    {
        id: "vaporwave-aesthetic",
        name: "Vaporwave",
        prePrompt: "vaporwave aesthetic, sunset gradients of pink to purple to teal, retro grid horizon, classical statues, glitch textures, dreamy nostalgia",
        emoji: "🌅",
        realism: "illustrative",
        sortOrder: 190,
    },
    {
        id: "ukiyo-e-woodblock",
        name: "Ukiyo-e xilografia",
        prePrompt: "Japanese ukiyo-e woodblock print, flat planes of color, confident black outlines, decorative wave and cloud motifs, indigo and earth pigments",
        emoji: "🌊",
        realism: "illustrative",
        sortOrder: 200,
    },
    {
        id: "cyanotype-blueprint",
        name: "Cianotipo blueprint",
        prePrompt: "cyanotype blueprint look, rich Prussian blue background, white silhouettes and line work, slight paper texture, vintage scientific feel",
        emoji: "📐",
        realism: "illustrative",
        sortOrder: 210,
    },
    {
        id: "claymation",
        name: "Claymation",
        prePrompt: "stop-motion claymation look, sculpted plasticine textures, visible fingerprints, soft studio lighting, slightly imperfect shapes, warm pastel palette",
        emoji: "🧱",
        realism: "illustrative",
        sortOrder: 220,
    },
    {
        id: "comic-pop-halftone",
        name: "Comic pop halftone",
        prePrompt: "pop-art comic book style, bold black ink outlines, Ben-Day halftone dots, primary palette with red and yellow accents, dynamic compositions",
        emoji: "💥",
        realism: "illustrative",
        sortOrder: 230,
    },
    {
        id: "art-nouveau-botanical",
        name: "Art nouveau botanico",
        prePrompt: "Art Nouveau botanical illustration, sinuous organic linework, floral and vine motifs, muted gold and sage palette, ornamental framing",
        emoji: "🌿",
        realism: "illustrative",
        sortOrder: 240,
    },
    {
        id: "origami-paper-craft",
        name: "Origami paper craft",
        prePrompt: "origami paper craft scene, crisp folded paper geometry, soft directional studio light, subtle paper texture, monochromatic accent on neutral background",
        emoji: "📄",
        realism: "illustrative",
        sortOrder: 250,
    },
    {
        id: "solarpunk-lush",
        name: "Solarpunk lussureggiante",
        prePrompt: "solarpunk lush utopia, sunlit greenery, art-nouveau curves, soft warm light, biophilic architecture, optimistic palette of leaf greens and warm yellows",
        emoji: "🌱",
        realism: "illustrative",
        sortOrder: 260,
    },
    {
        id: "hand-drawn-sketch",
        name: "Schizzo a mano",
        prePrompt: "loose hand-drawn pencil sketch, visible cross-hatching, sepia ink wash, paper grain, casual editorial sketchbook aesthetic",
        emoji: "✏️",
        realism: "illustrative",
        sortOrder: 270,
    },
    {
        id: "polaroid-film",
        name: "Polaroid analogica",
        prePrompt: "polaroid instant film photograph, faded warm cast, slight light leak, soft focus, vintage 1970s color science, square frame composition",
        emoji: "📸",
        realism: "illustrative",
        sortOrder: 280,
    },
    {
        id: "isometric-tech",
        name: "Isometrico tech",
        prePrompt: "isometric vector tech illustration, 30-degree axonometric, clean line accents, soft drop shadows, friendly SaaS palette of indigo and teal",
        emoji: "🧊",
        realism: "illustrative",
        sortOrder: 290,
    },
    {
        id: "minimalist-line-art",
        name: "Line art minimalista",
        prePrompt: "minimalist single-weight line art, mostly white background, one accent color fill, generous whitespace, calm editorial feel",
        emoji: "➰",
        realism: "illustrative",
        sortOrder: 300,
    },
    {
        id: "brutalist-editorial",
        name: "Brutalista editoriale",
        prePrompt: "brutalist editorial design, raw concrete textures, oversized sans-serif typography sensibility, stark high contrast, monochrome with single accent",
        emoji: "🧱",
        realism: "illustrative",
        sortOrder: 310,
    },
    {
        id: "photo-product-studio-catalog",
        name: "Foto prodotto studio",
        prePrompt: "commercial product photograph on seamless white cyclorama, Phase One IQ4 150MP with 120mm macro, soft three-point studio strobes, razor-sharp focus, credible packaging micro-texture and specular highlights, high-end ecommerce catalogue aesthetic, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "📦",
        realism: "photoreal",
        sortOrder: 315,
    },
    {
        id: "photo-analog-reportage-portra",
        name: "Foto analogica documentaria",
        prePrompt: "documentary analog photograph, Leica M6 with 35mm Summicron, Kodak Portra 400 color science, subtle 35mm film grain and halation, ambient natural mixed light, candid decisive-moment framing, restrained contrast, tactile print feel, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "🎞️",
        realism: "photoreal",
        sortOrder: 318,
    },
    {
        id: "photo-natural-light-portrait",
        name: "Ritratto luce naturale",
        prePrompt: "editorial portrait photograph in natural daylight, Sony A7IV with 85mm f/1.4, diffused window light, shallow depth of field with creamy bokeh, accurate skin pores and catchlights, minimal retouch beauty look, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "🌤️",
        realism: "photoreal",
        sortOrder: 321,
    },
    {
        id: "photo-gourmet-macro-food",
        name: "Food macro gastronomico",
        prePrompt: "macro gastronomic food photograph, Hasselblad H6D-100c with 80mm macro, sculpted side key and dark negative fill, exaggerated appetizing moisture and sauce texture, restaurant editorial plating, rich believable saturation, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "🍽️",
        realism: "photoreal",
        sortOrder: 324,
    },
    {
        id: "photo-architecture-blue-twilight",
        name: "Architettura blu ora",
        prePrompt: "architectural exterior photograph at blue hour, tilt-shift corrected perspective, Canon EOS R5 with 24mm TS-E, HDR-balanced façade lighting, crystalline glazing reflections, deep dusk sky gradient, tripod-sharp clarity, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "🏙️",
        realism: "photoreal",
        sortOrder: 327,
    },
    {
        id: "photo-street-reportage-35mm",
        name: "Reportage urbano 35mm",
        prePrompt: "candid street reportage photograph, Leica Q3 with 28mm equivalent, natural mixed urban light, unposed people in motion, decisive moment framing, subtle film grain, restrained color grading, documentary honesty, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "🚶",
        realism: "photoreal",
        sortOrder: 330,
    },
    {
        id: "photo-golden-hour-lifestyle",
        name: "Lifestyle golden hour",
        prePrompt: "outdoor lifestyle photograph at golden hour, Canon R6 with 50mm f/1.2, warm backlight rim on real people in candid relaxed poses, soft lens flare, natural skin tones, editorial travel-magazine mood, believable environment, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "🌅",
        realism: "photoreal",
        sortOrder: 335,
    },
    {
        id: "photo-environmental-portrait",
        name: "Ritratto ambientato",
        prePrompt: "environmental portrait photograph on location, Fujifilm GFX 100S with 63mm, subject in authentic workplace context, balanced ambient light with subtle fill, medium format depth, narrative storytelling composition, credible real-world details, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "👤",
        realism: "photoreal",
        sortOrder: 340,
    },
    {
        id: "photo-candid-family-home",
        name: "Famiglia in casa",
        prePrompt: "candid family photograph at home, Nikon Z6II with 35mm f/1.8, soft window daylight, unposed intimate moments, shallow depth of field, warm domestic palette, gentle film grain, authentic lived-in interiors, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "🏠",
        realism: "photoreal",
        sortOrder: 345,
    },
    {
        id: "photo-travel-storytelling",
        name: "Viaggio narrativo",
        prePrompt: "travel storytelling photograph, Sony A7C with 24-70mm f/2.8, mix of wide establishing shots and intimate details, natural available light, real destinations and locals, editorial photo essay rhythm, honest color, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "✈️",
        realism: "photoreal",
        sortOrder: 350,
    },
    {
        id: "photo-event-flash-ambient",
        name: "Eventi flash + ambiente",
        prePrompt: "event photograph blending on-camera flash with ambient room light, Canon 5D Mark IV with 35mm f/1.4, candid guests and speakers, realistic motion blur on dancing crowds, mixed color temperature, photojournalistic energy, no staged poses, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "🎉",
        realism: "photoreal",
        sortOrder: 355,
    },
    {
        id: "photo-nature-wildlife-telephoto",
        name: "Natura teleobiettivo",
        prePrompt: "nature and wildlife photograph, Nikon D850 with 600mm f/4 telephoto compression, creamy background bokeh, crisp feather and fur texture, golden-hour or overcast natural light, patient observational framing, National Geographic realism, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "🦅",
        realism: "photoreal",
        sortOrder: 360,
    },
    {
        id: "photo-landscape-figures-wide",
        name: "Paesaggio con figure",
        prePrompt: "landscape photograph with human figures for scale, Sony A7R V with 16-35mm f/2.8 ultra-wide, dramatic natural sky, deep focus, believable terrain textures, adventure editorial mood, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "⛰️",
        realism: "photoreal",
        sortOrder: 365,
    },
    {
        id: "photo-sports-amateur-action",
        name: "Sport amatoriale",
        prePrompt: "amateur sports action photograph, Canon R3 with 70-200mm f/2.8, panning motion blur on background with sharp subject, stadium or park ambient light, sweat and fabric texture, dynamic diagonal composition, energetic photoreal capture, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "⚽",
        realism: "photoreal",
        sortOrder: 370,
    },
    {
        id: "photo-bts-cinema-set",
        name: "Backstage cinema",
        prePrompt: "behind-the-scenes cinema set photograph, Leica SL2 with 50mm Summilux, mixed continuous tungsten and daylight, crew and actors in candid moments, shallow depth of field, production equipment visible, documentary film-industry atmosphere, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "🎬",
        realism: "photoreal",
        sortOrder: 375,
    },
    {
        id: "photo-cafe-conversation-warm",
        name: "Bar e conversazione",
        prePrompt: "warm café interior photograph, Fujifilm X-T5 with 23mm f/1.4, intimate table-side framing, shallow depth of field, tungsten ambient glow, steam and glass reflections, cozy editorial mood, candid social atmosphere, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "☕",
        realism: "photoreal",
        sortOrder: 380,
    },
    {
        id: "photo-rainy-window-mood",
        name: "Pioggia sul vetro",
        prePrompt: "moody rainy-day photograph through window glass, Sony A7III with 35mm f/1.8, water droplets and soft diffusion, cool desaturated palette with warm interior accents, cinematic melancholy realism, urban or domestic setting, shot on real camera, raw photograph, true-to-life skin texture and material detail, no illustration, no painting, no 3D render, no CGI",
        emoji: "🌧️",
        realism: "photoreal",
        sortOrder: 385,
    },
];
export function getPulsePreset(id) {
    return PULSE_PRESET_CATALOG.find((p) => p.id === id);
}
export const DEFAULT_PULSE_PRESET_ID = "flat-editorial";
